import { defineMessages } from 'react-intl'

const pageComponentsMessages = {
  ActivitySection: defineMessages({
    physicalCourses: {
      id: 'pageComponents.ActivitySection.physicalCourses',
      defaultMessage: '實體課程',
    },
  }),
  BlndCTASection: defineMessages({
    joinUs: {
      id: 'pageComponents.blndCTASection.joinUs',
      defaultMessage: 'JOIN US',
    },
    joinBlnd: {
      id: 'pageComponents.blndCTASection.joinBlnd',
      defaultMessage: '加入BLND，向你的專業目標邁出下一步',
    },
    startMyCourse: {
      id: 'pageComponents.blndCTASection.startMyCourse',
      defaultMessage: '開始我的課程',
    },
  }),
  BlndPostSection: defineMessages({
    blog: {
      id: 'pageComponents.blndPostSection.blog',
      defaultMessage: 'BLOG',
    },
    extendedReading: {
      id: 'pageComponents.blndPostSection.extendedReading',
      defaultMessage: '延伸閱讀',
    },
  }),
  InstructorCraftSection: defineMessages({
    professionalInstructors: {
      id: 'pageComponents.instructorCraftSection.professionalInstructors',
      defaultMessage: '專業師資',
    },
  }),
  LittlestarLastTimePodcastSection: defineMessages({
    continuePlaying: {
      id: 'pageComponents.littlestarLastTimePodcastSection.continuePlaying',
      defaultMessage: '繼續播放',
    },
  }),
  MisaNavigationBar: defineMessages({
    intro: {
      id: 'pageComponents.misaNavigationBar.intro',
      defaultMessage: 'MISA簡介',
    },
    chairman: {
      id: 'pageComponents.misaNavigationBar.chairman',
      defaultMessage: '理事長的話',
    },
    coFounder: {
      id: 'pageComponents.misaNavigationBar.coFounder',
      defaultMessage: '共同創辦人',
    },
    directorList: {
      id: 'pageComponents.misaNavigationBar.directorList',
      defaultMessage: '理監事名單',
    },
  }),
  PostSection: defineMessages({
    blogColumn: {
      id: 'pageComponents.postSection.blogColumn',
      defaultMessage: '部落格專欄',
    },
  }),
  CreatorSection: defineMessages({
    partnerInstructor: {
      id: 'pageComponents.creatorSection.partnerInstructor',
      defaultMessage: '合作講師',
    },
  }),
}

export default pageComponentsMessages
